<div class="header">
  <div id="title-wrapper">
    <i i-bs id="close-button" name="x" class="icon-btn" width="24" height="24" aria-label="Retour" (click)="tryToClose()"></i>
    <h3 id="title-text">Édition de "{{patientGroup?.name ?? 'Groupe inconnu'}}"</h3>
  </div>
  <msd-search-bar (searchEvent)="updateSearchQuery($event)"></msd-search-bar>
</div>
<div *ngIf="!error && !isLoading && visiblePatients && visiblePatients.length > 0; else innerLoading"
  id="patient-list">
  <msd-patient-cell (checkChange)="toggleCheck(p)"
                    *ngFor="let p of visiblePatients"
                    [archived]="p.archived"
                    [checkable]="true"
                    [checked]="p.checked"
                    [initials]="p.initials"
                    [name]="p.fullName"
                    [pictureUrl]="p.pictureUrl">
  </msd-patient-cell>
</div>

<ng-template #innerLoading>
  <ngx-inner-loading (retry)="searchPatients(currentQuery)"
                     [emptyDescription]="'Aucun patient trouvé'"
                     [empty]="visiblePatients?.length === 0"
                     [errorDescription]="error"
                     [error]="!!error"
                     [loadingDescription]="'Chargement...'"
                     [loading]="isLoading"
                     [retryButtonText]="'Réessayer'"
                     class="flex-center"
                     id="loader">
  </ngx-inner-loading>
</ng-template>

<div class="footer">
  <div id="cancel-button" (click)="tryToClose()"
    class="icon-text-button">
    <span class="text-button-text">Annuler</span>
  </div>

  <button (click)="preUpdatePatientGroup()"
          [disabled]="isLoading"
          class="btn btn-primary btn-gradient"
          id="save-button"
          type="submit">
    <ng-container *ngIf="isLoading; else saveButton">
      <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
      <span class="visually-hidden">Chargement...</span>
    </ng-container>
    <ng-template #saveButton>
      Sauvegarder
    </ng-template>
  </button>
</div>
